import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

// ✅ Typewriter Component
const TypewriterText = ({ text, delay = 80 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, delay);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, text]);

  return (
    <>
      {displayedText}
      <span className="border-r-2 border-black animate-pulse ml-1"></span>
    </>
  );
};

const AnythingElseSection = () => {
  const headingText = "The answers to your questions.";

  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What does Twin Star Industries manufacture?",
      answer:
        "Twin Star Industries specializes in manufacturing high-precision fasteners and machined components for a range of industries, including automotive, agriculture, aerospace, and lift systems.",
    },
    {
      question: "Since when has Twin Star Industries been in business?",
      answer:
        "Proudly serving global industries since 1981, Twin Star Industries is your trusted source for reliable components.",
    },
    {
      question: "Which certifications does Twin Star Industries hold?",
      answer:
        "   Twin Star Industries is IATF 16949:2016 certified by TÜV SÜD, ensuring compliance with the highest quality standards in the automotive industry. We are also recognized as a MACE Green Vendor, reflecting our commitment to sustainable and environmentally responsible manufacturing.",
    },
    {
      question: "What kind of machinery do you use?",
      answer:
        "Our manufacturing facilities are equipped with a wide range of advanced machinery to ensure high-precision production and operational efficiency. We utilize TRAUB machines, CNC machining centers, capstan lathes, slotting machines, milling machines, grinding equipment (including surface and bench grinding), as well as thread rolling, drilling, and barrelling machines. This comprehensive setup enables us to produce reliable, high-quality components across various industries and applications.   (or)      Our facility is equipped with advanced TRAUB machines, CNC machining centers, capstan lathes, slotting machines, milling machines, surface and bench grinders, as well as rolling, drilling, and barrelling machines—enabling us to deliver high-precision components with efficiency and consistency.",
    },
    {
      question: "How do you ensure quality and performance?",
      answer:
        " We ensure quality and performance through strict in-house quality controls and continuous process monitoring. Our customer PPM consistently ranges between 0–5, and our in-house PPM remains below 100-demonstrating our commitment to near-zero defect supplies and industry-leading reliability.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 px-6 lg:px-12 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* ✅ Heading */}
        <div className="mb-10">
          <span className="flex items-center gap-2 mb-3">
            <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
            <span className="text-base sm:text-lg font-medium">
              Anything else?
            </span>
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-snug">
            <TypewriterText text={headingText} delay={70} />
          </h2>
        </div>

        {/* ✅ FAQ Accordion */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div></div> {/* empty space on left for large screens */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl shadow-sm p-6 cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-semibold">{faq.question}</h3>
                  {openIndex === index ? (
                    <ChevronUp className="w-6 h-6 text-black" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-black" />
                  )}
                </div>

                {/* ✅ Smooth transition */}
                <div
                  className={`transition-all duration-500 ease-in-out overflow-hidden ${
                    openIndex === index
                      ? "max-h-40 opacity-100 mt-3"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnythingElseSection;
